import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { addDoc, collection, doc, getDocs, orderBy, query, updateDoc, where } from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { auth, db } from "../Config/firebase";
import { gerarSequencial, obterMaiorSequencial } from "../Utils/sequencial";
import { aplicarTenantAtual, consultaTenantAtual, getUsuarioAtualComTenant } from "../Utils/tenant";
import { podeEditarCadastroDireto, solicitarAprovacaoCadastro } from "../Utils/aprovacaoCadastro";

const hoje = () => new Date().toISOString().slice(0, 10);
const estadoInicial = {
  codigo: "", dataRelatorio: hoje(), cliente: "", clienteId: "", obra: "", obraId: "",
  fornecedor: "", moldadoPor: "", dataMoldagem: "", dataEnsaio: "", abatimento: "", idade: "",
};
const dataBR = (valor) => valor?.includes("-") ? valor.split("-").reverse().join("/") : valor || "-";
const calcularIdade = (dataMoldagem, dataEnsaio) => {
  if (!dataMoldagem || !dataEnsaio) return "";
  const inicio = new Date(`${dataMoldagem}T12:00:00`);
  const fim = new Date(`${dataEnsaio}T12:00:00`);
  const dias = Math.round((fim - inicio) / 86400000);
  return dias >= 0 ? dias : "";
};

export default function CadastroArgamassa() {
  const history = useHistory();
  const [ensaios, setEnsaios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [obras, setObras] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [form, setForm] = useState(estadoInicial);
  const [aberto, setAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [carregandoLista, setCarregandoLista] = useState(true);
  const [filtro, setFiltro] = useState("");

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const [ensaiosSnap, clientesSnap] = await Promise.all([
      getDocs(consultaTenantAtual(query(collection(db, "tblEnsaiosArgamassa"), orderBy("criadoEm", "desc")))),
      getDocs(consultaTenantAtual(query(collection(db, "clientes"), orderBy("nome", "asc")))),
    ]);
    setEnsaios(ensaiosSnap.docs.map((item) => ({ id: item.id, ...item.data() })));
    setClientes(clientesSnap.docs.map((item) => ({ id: item.id, ...item.data() })));
    setCarregandoLista(false);
  }

  async function carregarObras(clienteId) {
    if (!clienteId) return setObras([]);
    const snap = await getDocs(consultaTenantAtual(query(collection(db, "obras"), where("clienteId", "==", clienteId), orderBy("nome", "asc"))));
    setObras(snap.docs.map((item) => ({ id: item.id, ...item.data() })));
  }

  function novo() {
    setEditando(null); setCliente(null); setObras([]); setForm(estadoInicial); setAberto(true);
  }

  async function editar(item) {
    setEditando(item);
    setCliente(clientes.find((clienteItem) => clienteItem.id === item.clienteId) || null);
    await carregarObras(item.clienteId);
    setForm({
      ...estadoInicial,
      ...item,
    });
    setAberto(true);
  }

  async function salvar(abrirAposSalvar = false) {
    if (!form.clienteId || !form.obraId || !form.dataMoldagem || !form.dataEnsaio) {
      alert("Selecione cliente, obra, data da moldagem e data do ensaio."); return;
    }
    setSalvando(true);
    try {
      const ano = new Date(form.dataRelatorio || form.dataEnsaio).getFullYear();
      const codigo = editando?.id ? form.codigo : form.codigo || (await gerarSequencial({
        chave: "argamassa", escopo: ano,
        formato: { padding: 3, ano, template: "CE-RE-RTC-{numero}/{ano}" },
        valorMinimo: obterMaiorSequencial(ensaios, /CE-RE-RTC-(\d+)\//),
      })).codigo;
      const dados = { ...form, codigo, idade: form.idade || calcularIdade(form.dataMoldagem, form.dataEnsaio), atualizadoEm: new Date(), atualizadoPor: auth.currentUser?.email || null };
      let id = editando?.id;
      if (id) {
        const usuarioAtual = await getUsuarioAtualComTenant();
        if (podeEditarCadastroDireto(usuarioAtual, editando)) {
          await updateDoc(doc(db, "tblEnsaiosArgamassa", id), dados);
        } else {
          await solicitarAprovacaoCadastro({
            usuario: usuarioAtual,
            registro: editando,
            colecao: "tblEnsaiosArgamassa",
            registroId: id,
            dados,
            tipo: "argamassa",
            titulo: `Alteração do ensaio de argamassa ${editando.codigo || ""}`,
          });
          alert("Alteração enviada para aprovação do administrador.");
        }
      } else {
        const ref = await addDoc(collection(db, "tblEnsaiosArgamassa"), aplicarTenantAtual({ ...dados, criadoEm: new Date(), criadoPor: auth.currentUser?.email || null }));
        id = ref.id;
      }
      setAberto(false); await carregar();
      if (abrirAposSalvar) history.push(`/app/ensaio-argamassa/${id}`);
    } catch (error) {
      console.error("Erro ao salvar ensaio de argamassa:", error);
      alert(error?.message || "Não foi possível salvar o ensaio de argamassa.");
    } finally { setSalvando(false); }
  }

  const lista = useMemo(() => ensaios.filter((item) => contemTextoPesquisa([item.codigo, item.cliente, item.obra, item.fornecedor].join(" ").toLowerCase(), filtro.toLowerCase())), [ensaios, filtro]);
  const alterar = (campo) => (event) => setForm((anterior) => ({ ...anterior, [campo]: event.target.value }));

  return <>
    <Navbar />
    <Box className="lista-cadastro-padrao" sx={{ p: { xs: 2, md: 4 } }}>
      <Paper className="cabecalho-lista-cadastro" elevation={0}>
      <Typography variant="h6" fontWeight={700}>Ensaio de argamassa</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>Resistência à tração na flexão e à compressão</Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={3}><Button variant="contained" onClick={novo}>+ Novo ensaio</Button><TextField size="small" label="Pesquisar" value={filtro} onChange={alterarFiltro => setFiltro(alterarFiltro.target.value)} sx={{ flex: 1 }} /></Stack>
      </Paper>
      <Paper sx={{ overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}><Table className="lista-cadastro-padrao" size="small"><TableHead><TableRow><TableCell>Código</TableCell><TableCell>Cliente / Obra</TableCell><TableCell>Data</TableCell><TableCell>Fornecedor</TableCell><TableCell align="center">Ações</TableCell></TableRow></TableHead><TableBody>
        {lista.map((item) => <TableRow hover key={item.id} sx={{ cursor: "pointer" }} onClick={() => history.push(`/app/ensaio-argamassa/${item.id}`)}><TableCell>{item.codigo}</TableCell><TableCell><div className="lista-dado-principal">{item.cliente || "-"}</div><div className="lista-dado-secundario">Obra: {item.obra || "-"}</div></TableCell><TableCell className="lista-dado-secundario">{dataBR(item.dataEnsaio)}</TableCell><TableCell className="lista-dado-destaque">{item.fornecedor || "-"}</TableCell><TableCell align="center"><Tooltip title="Visualizar relatório"><IconButton size="small" onClick={(e) => { e.stopPropagation(); history.push(`/app/ensaio-argamassa/${item.id}?relatorio=true`); }}><VisibilityIcon color="primary" /></IconButton></Tooltip><Tooltip title="Editar"><IconButton size="small" onClick={(e) => { e.stopPropagation(); editar(item); }}><EditIcon sx={{ color: "#0288d1" }} /></IconButton></Tooltip><HistoricoCadastro colecao="tblEnsaiosArgamassa" documentoId={item.id} registro={item} /></TableCell></TableRow>)}
        {carregandoLista && <TableRow><TableCell colSpan={5}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
        {!carregandoLista && !lista.length && <TableRow><TableCell colSpan={5} align="center">Nenhum ensaio cadastrado.</TableCell></TableRow>}
      </TableBody></Table></Paper>
    </Box>
    <Dialog open={aberto} onClose={() => setAberto(false)} fullWidth maxWidth="sm"><DialogTitle>{editando ? "Editar ensaio de argamassa" : "Novo ensaio de argamassa"}</DialogTitle><DialogContent dividers><Stack spacing={2} mt={1}>
      <TextField label="Código" value={form.codigo} onChange={alterar("codigo")} />
      <Autocomplete options={clientes} getOptionLabel={(o) => o?.nome || ""} isOptionEqualToValue={(a, b) => a.id === b.id} value={cliente} onChange={(_, valor) => { setCliente(valor); setForm((f) => ({ ...f, clienteId: valor?.id || "", cliente: valor?.nome || "", obraId: "", obra: "" })); carregarObras(valor?.id); }} renderInput={(params) => <TextField {...params} label="Cliente" />} />
      <TextField select label="Obra" value={form.obraId} onChange={(e) => { const obra = obras.find((item) => item.id === e.target.value); setForm((f) => ({ ...f, obraId: obra?.id || "", obra: obra?.nome || "" })); }} disabled={!form.clienteId}>{obras.map((obra) => <MenuItem key={obra.id} value={obra.id}>{obra.nome}</MenuItem>)}</TextField>
      <TextField label="Fornecedor" value={form.fornecedor} onChange={alterar("fornecedor")} /><TextField label="Moldado por" value={form.moldadoPor} onChange={alterar("moldadoPor")} />
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}><TextField fullWidth type="date" label="Data do relatório" InputLabelProps={{ shrink: true }} value={form.dataRelatorio} onChange={alterar("dataRelatorio")} /><TextField fullWidth type="date" label="Data da moldagem" InputLabelProps={{ shrink: true }} value={form.dataMoldagem} onChange={(event) => setForm((anterior) => ({ ...anterior, dataMoldagem: event.target.value, idade: calcularIdade(event.target.value, anterior.dataEnsaio) }))} /></Stack>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}><TextField fullWidth type="date" label="Data do ensaio" InputLabelProps={{ shrink: true }} value={form.dataEnsaio} onChange={(event) => setForm((anterior) => ({ ...anterior, dataEnsaio: event.target.value, idade: calcularIdade(anterior.dataMoldagem, event.target.value) }))} /><TextField fullWidth label="Idade (dias)" type="number" value={form.idade} onChange={alterar("idade")} /><TextField fullWidth label="Abatimento" value={form.abatimento} onChange={alterar("abatimento")} /></Stack>
    </Stack></DialogContent><DialogActions><Button onClick={() => setAberto(false)}>Cancelar</Button><Button onClick={() => salvar(false)} disabled={salvando}>Salvar</Button><Button variant="contained" onClick={() => salvar(true)} disabled={salvando}>{salvando ? "Salvando..." : "Salvar e abrir"}</Button></DialogActions></Dialog>
  </>;
}
